export default (function () {
  // Wrap every letter in a span
  var textWrapper = $('.animated-text-slider__left-text');
  textWrapper.each(function (i) {
    $(this).find('p').contents().filter(function () {
      return this.nodeType == 3;
    }).wrap('<div class="animated-text-slider__left-text-part"></div>');
    $(this).find('.animated-text-slider__left-text-part').each(function (i) {
      $(this).html($(this).text().replace(/\S/g, '<span class=\'letter\'>$&</span>'));
      var currentSlide = i + 1;
      var targets = '.animated-text-slider__left-text-' + currentSlide + ' .animated-text-slider__left-text-part .letter';
      anime.timeline({
        loop: false
      }).add({
        targets: targets,
        translateY: [100, 0],
        translateZ: 0,
        opacity: [0, 1],
        easing: 'easeOutExpo',
        duration: 1400,
        delay: function delay(el, i) {
          return 300 + 30 * i * 2;
        }
      }).add({
        targets: targets,
        translateY: [0, -100],
        opacity: [1, 0],
        easing: 'easeInExpo',
        duration: 1200,
        delay: function delay(el, i) {
          return 3000 + 30 * i;
        }
      });
    });
  });
  var textWrapper2 = $('.animated-text-slider__right-text');
  textWrapper2.each(function (i) {
    $(this).find('p').contents().filter(function () {
      return this.nodeType == 3;
    }).wrap('<div class="animated-text-slider__right-text-part"></div>');
    $(this).find('.animated-text-slider__right-text-part').each(function (i) {
      $(this).html($(this).text().replace(/\S/g, '<span class=\'letter\'>$&</span>'));
      var currentSlide = i + 1;
      var targets = '.animated-text-slider__right-text-' + currentSlide + ' .animated-text-slider__right-text-part .letter';

      if (window.matchMedia('(max-width: 767px)').matches) {
        anime.timeline({
          loop: false
        }).add({
          targets: targets,
          translateY: [100, 0],
          translateZ: 0,
          opacity: [0, 1],
          easing: 'easeOutExpo',
          duration: 1400,
          delay: function delay(el, i) {
            return 300 + 30 * i;
          }
        }).add({
          targets: targets,
          translateY: [0, -100],
          opacity: [1, 0],
          easing: 'easeInExpo',
          duration: 1200,
          delay: function delay(el, i) {
            return 4000 + 30 * i;
          }
        });
      } else {
        anime.timeline({
          loop: false
        }).add({
          targets: targets,
          translateY: [100, 0],
          translateZ: 0,
          opacity: [0, 1],
          easing: 'easeOutExpo',
          duration: 1400,
          delay: function delay(el, i) {
            return 300 + 30 * i;
          }
        }).add({
          targets: targets,
          translateY: [0, -100],
          opacity: [1, 0],
          easing: 'easeInExpo',
          duration: 1200,
          delay: function delay(el, i) {
            return 3000 + 30 * i;
          }
        });
      }
    });
  });
});